export const linkTypes = {
  TEL: 'tel',
}
